import { useEffect } from "react";
import buttonStyles from "../../../styles/UI/buttons.module.css";

const IconButtonComponent = ({
  icon,
  id,
  onClick,
  classes,
  disable,
  width,
  height,
  ariaLabel,
  activeColor,
}: {
  id: string;
  icon: React.ReactNode;
  onClick: () => void;
  classes?: string;
  disable?: boolean;
  width?: number;
  height?: number;
  ariaLabel: string;
  activeColor?: string;
}) => {
  // useEffect to programaticcaly set the color of icon.
  useEffect(() => {
    if (disable === undefined) return;
    const buttonElement = document.getElementById(id);
    const color = disable
      ? "var(--col-graph-first-1)"
      : (activeColor ?? "var(--col-interaction-secondary)");
    buttonElement?.querySelectorAll("path").forEach((el) => {
      if (el.getAttribute("fill") !== "none") el.setAttribute("fill", color);
      if (el.getAttribute("stroke") && el.getAttribute("stroke") !== "none") {
        el.setAttribute("stroke", color);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disable]);

  return (
    <button
      aria-label={ariaLabel}
      id={id}
      className={`${classes || null} ${buttonStyles.iconButton}`}
      onClick={onClick}
      disabled={disable}
      style={{
        width: width ? `${width}px` : "40px",
        height: height ? `${height}px` : "40px",
      }}
    >
      {icon}
    </button>
  );
};

export default IconButtonComponent;
